import { getAppConfig } from '../config/appConfigRef';

export function getStoredToken(): string | null {
  return localStorage.getItem(getAppConfig().tokenKey);
}

export function setStoredToken(token: string): void {
  localStorage.setItem(getAppConfig().tokenKey, token);
}

export function removeStoredToken(): void {
  localStorage.removeItem(getAppConfig().tokenKey);
}
